var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty)?_c('TagsBadges',{attrs:{"tags":_vm.tags}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }